// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-5211a897]{\n\tpadding: 10px 15px;\n\tbackground-color: var(--main-gray-5);\n\tcolor:white;\n\t-webkit-box-sizing: border-box;\n\t        box-sizing: border-box;\n}\n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
